export default class Modal {
  constructor() {
    this.init();
  }
  init() {
    const trigger = $(".esf-js-modalTrigger");
    const overlay = $(".esf-overlay[data-modal]");

    trigger.click(function() {
      let data = $(this).attr("data-modal");
      let elements = $(".esf-overlay[data-modal=" + data + "], .esf-modal[data-modal=" + data + "]");

      overlay.appendTo(".esf-main-layout");
      $("body").addClass("-is-frozen");

      elements
        .removeClass("-is-closed")
        .addClass("-is-open");
    });

    overlay.click(function(e) {
      let data = $(this).attr("data-modal");
      let elements = $(".esf-overlay[data-modal=" + data + "], .esf-modal[data-modal=" + data + "]");
      let clicked = $(e.target);

      if (clicked.is(".esf-js-closeModal")) {
        $("body").removeClass("-is-frozen");

        elements.addClass("-is-closed");
        setTimeout(function(){
          elements.removeClass("-is-open");
        }, 300);
      }
    });
  }
}
